export default __webpack_public_path__ + "static/media/slider1.38d56bd9.jpg";